var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SimpleTableCell, SimpleTableHeaderCell } from '@core';
import { useMemo } from 'react';
import { DesigningRwTable } from './designing-rw-table.component';
export var CombinedSoundReductionTable = function (_a) {
    var _b = _a.frequencyLabels, frequencyLabels = _b === void 0 ? [] : _b, _c = _a.rLab, rLab = _c === void 0 ? [] : _c, _d = _a.rInSitu, rInSitu = _d === void 0 ? [] : _d, labRw = _a.labRw, computingRw = _a.computingRw, delta = _a.delta, c = _a.c, ctr = _a.ctr, _e = _a.noPadding, noPadding = _e === void 0 ? false : _e;
    var tableData = useMemo(function () {
        var rawData = frequencyLabels.map(function (f, index) {
            var _a, _b;
            return ({
                frequency: f.toString(),
                rLab: ((_a = rLab[index]) !== null && _a !== void 0 ? _a : 0).toString(),
                rInSitu: ((_b = rInSitu[index]) !== null && _b !== void 0 ? _b : 0).toString(),
            });
        });
        var sortedData = rawData.sort(function (a, b) { return Number(a.frequency) - Number(b.frequency); });
        var finalData = __spreadArray(__spreadArray([], sortedData, true), [
            {
                frequency: 'Rw',
                rLab: (labRw !== null && labRw !== void 0 ? labRw : 0).toString(),
                rInSitu: (computingRw !== null && computingRw !== void 0 ? computingRw : 0).toString(),
            },
            {
                frequency: 'Ctr',
                rLab: "(".concat(delta !== null && delta !== void 0 ? delta : 0, ", ").concat(ctr !== null && ctr !== void 0 ? ctr : 0, ")"),
                rInSitu: "(".concat(delta !== null && delta !== void 0 ? delta : 0, ", ").concat(ctr !== null && ctr !== void 0 ? ctr : 0, ")"),
            },
            {
                frequency: 'C50-5000',
                rLab: "(".concat(delta !== null && delta !== void 0 ? delta : 0, ", ").concat(c !== null && c !== void 0 ? c : 0, ")"),
                rInSitu: "(".concat(delta !== null && delta !== void 0 ? delta : 0, ", ").concat(c !== null && c !== void 0 ? c : 0, ")"),
            },
        ], false);
        return finalData;
    }, [frequencyLabels, rLab, rInSitu, labRw, computingRw, delta, c, ctr]);
    var columns = useMemo(function () { return [
        {
            accessorKey: 'frequency',
            header: function () { return (_jsx(SimpleTableHeaderCell, { text: "Freq, Hz", textClassName: "w-[60px] border-r border-[#EDEFF2] text-center", noPadding: noPadding })); },
            cell: function (info) { return (_jsx(SimpleTableCell, { content: info.getValue(), contentClassName: "w-[60px] border-r border-[#EDEFF2] text-center ".concat(info.row.original.frequency === 'Rw'
                    ? 'bg-[#CCCCCC] text-[#FF0000]'
                    : ''), noPadding: noPadding })); },
        },
        {
            accessorKey: 'rLab',
            header: function () { return (_jsx(SimpleTableHeaderCell, { text: "R (lab), dB", textClassName: "w-[80px] border-r border-[#EDEFF2] text-center", noPadding: noPadding })); },
            cell: function (info) { return (_jsx(SimpleTableCell, { content: info.getValue(), contentClassName: "w-[80px] border-r border-[#EDEFF2] text-center ".concat(info.row.original.frequency === 'Rw'
                    ? 'bg-[#CCCCCC] text-[#FF0000]'
                    : ''), noPadding: noPadding })); },
        },
        {
            accessorKey: 'rInSitu',
            header: function () { return (_jsx(SimpleTableHeaderCell, { text: "R' (in situ), dB", textClassName: "w-[90px] text-center", noPadding: noPadding })); },
            cell: function (info) { return (_jsx(SimpleTableCell, { content: info.getValue(), contentClassName: "w-[90px] text-center ".concat(info.row.original.frequency === 'Rw'
                    ? 'bg-[#CCCCCC] text-[#FF0000]'
                    : ''), noPadding: noPadding })); },
        },
    ]; }, [noPadding]);
    return (_jsx("div", __assign({ className: "flex-col" }, { children: _jsx(DesigningRwTable, { data: tableData, columns: columns, classNames: {
                tableClassName: 'border border-[#EDEFF2] border-collapse',
                headerCellClassName: 'border border-[#EDEFF2]',
                contentCellClassName: 'border border-[#EDEFF2]',
            } }) })));
};
